export const WHATSAPP_DM_URL = "https://wa.me/+27632144551";
export const WHATSAPP_COMMUNITY_URL = "https://whatsapp.com/channel/0029Vaoe9up4SpkHe4I5fJ0j";